// src/services/loyaltyCardApi.js
// Servicio para manejar operaciones de tarjetas de fidelización

import { dotoniwoofApi } from '../api/dotoniwooApi';

/**
 * Buscar tarjeta de fidelización por teléfono
 */
export const getLoyaltyCardByPhone = async (phone) => {
  try {
    const response = await dotoniwoofApi.get(`/loyaltyCard.php?phone=${phone}`);
    return { ok: true, status: response.status, data: response.data };
  } catch (error) {
    return {
      ok: false,
      status: error.response?.status || 500,
      data: error.response?.data || { message: 'Error de conexión' }
    };
  }
};

/**
 * Obtener todas las tarjetas de fidelización
 */
export const getAllLoyaltyCards = async () => {
  try {
    const response = await dotoniwoofApi.get('/loyaltyCard.php');
    return { ok: true, status: response.status, data: response.data };
  } catch (error) {
    return {
      ok: false,
      status: error.response?.status || 500,
      data: error.response?.data || { message: 'Error de conexión' }
    };
  }
};

/**
 * Obtener detalle de una tarjeta
 */
export const getLoyaltyCardById = async (id) => {
  try {
    const response = await dotoniwoofApi.get(`/loyaltyCard.php/${id}`);
    return { ok: true, status: response.status, data: response.data };
  } catch (error) {
    return {
      ok: false,
      status: error.response?.status || 500,
      data: error.response?.data || { message: 'Error de conexión' }
    };
  }
};

/**
 * Obtener historial de sellos de una tarjeta
 */
export const getStampHistory = async (cardId) => {
  try {
    const response = await dotoniwoofApi.get(`/loyaltyCard.php/${cardId}/stamps`);
    return { ok: true, status: response.status, data: response.data };
  } catch (error) {
    return {
      ok: false,
      status: error.response?.status || 500,
      data: error.response?.data || { message: 'Error de conexión' }
    };
  }
};

/**
 * Crear nueva tarjeta de fidelización
 */
export const createLoyaltyCard = async (id_client, stamps_required = 10) => {
  try {
    const response = await dotoniwoofApi.post('/loyaltyCard.php', {
      id_client,
      stamps_required
    });
    return { ok: true, status: response.status, data: response.data };
  } catch (error) {
    return {
      ok: false,
      status: error.response?.status || 500,
      data: error.response?.data || { message: 'Error de conexión' }
    };
  }
};

/**
 * Agregar sello a una tarjeta
 */
export const addStamp = async (cardId, added_by = null) => {
  try {
    const body = added_by ? { added_by } : {};
    const response = await dotoniwoofApi.post(`/loyaltyCard.php/${cardId}/stamp`, body);
    return { ok: true, status: response.status, data: response.data };
  } catch (error) {
    return {
      ok: false,
      status: error.response?.status || 500,
      data: error.response?.data || { message: 'Error de conexión' }
    };
  }
};

/**
 * Eliminar tarjeta de fidelización
 */
export const deleteLoyaltyCard = async (cardId) => {
  try {
    const response = await dotoniwoofApi.delete(`/loyaltyCard.php/${cardId}`);
    return { ok: true, status: response.status, data: response.data };
  } catch (error) {
    return {
      ok: false,
      status: error.response?.status || 500,
      data: error.response?.data || { message: 'Error de conexión' }
    };
  }
};

/**
 * Obtener tarjetas de fidelización por ID de cliente
 * @param {number} clientId - ID del cliente
 * @returns {Promise<Object>} Lista de tarjetas de fidelización del cliente
 */
export const getLoyaltyCardsByClientId = async (clientId) => {
  try {
    const response = await dotoniwoofApi.get(`/loyaltyCard.php?client_id=${clientId}`);
    return { ok: true, status: response.status, data: response.data };
  } catch (error) {
    return {
      ok: false,
      status: error.response?.status || 500,
      data: error.response?.data || { message: 'Error de conexión' }
    };
  }
};






